import { Component, Vue } from 'vue-property-decorator'
import HighFilter from '@/components/highFilter/index.vue'
import { UserModule } from '@/store/modules/user'
@Component({ name: 'ProjectResultDetail', components: { HighFilter } })
export default class ProjectResultDetail extends Vue {
  private shareVisible = false
  private shareNextVisible = false
  private labelVisible = false
  private deteleVisible = false
  private renameVisible = false
  private templateVisible = false // 弹框类显示
  private multipleSelection: any = []
  private changeData: any = {}
  private tableData: any = [{
    date: '2016-05-03',
    name: '王小虎',
    province: '上海',
    city: '普陀区',
    address: '上海市普陀区金沙江路 1518 弄',
    zip: 200333
  }, {
    date: '2016-05-02',
    name: '王小虎',
    province: '上海',
    city: '普陀区',
    address: '上海市普陀区金沙江路 1518 弄',
    zip: 200333
  }, {
    date: '2016-05-04',
    name: '王小虎',
    province: '上海',
    city: '普陀区',
    address: '上海市普陀区金沙江路 1518 弄',
    zip: 200333
  }]

  private templateOptions: any = [{
    value: '0',
    name: '上海'
  }, {
    value: '1',
    name: '北京'
  }]

  private rowDataObj: any = {
    id: '1',
    name: 'ziliao'
  } // 搜索

  private totalPage = 1;
  private currentPage = 1;
  private filterData: any = {};
  private filterResult: any = null
  private showHighFilter = false
  private pageType: any = ''
  private searchVal = '' // 搜索
  private templateValue: any = '' // 模版绑定value
  private labelValue = '' // 标签绑定value
  private tableIndex = '' // 点击表格的index

  created () {
    // 1 .项目成果 2.项目资料
    this.pageType = this.$route.query.type
  }

  private async initPageData () {
    const param: any = { page: this.currentPage, limit: 20 }
    if (this.filterResult) {
      param.search = this.filterResult
    }
    // const result: any = await getStudentListByCourseType(param)
    // this.currentPage = result.currentPage
    // this.totalPage = result.allPage
    // this.tableData = result.studentList
    // this.filterData = result.search
  }

  private onPageChange (page: any) {
    this.currentPage = page
    this.initPageData()
  }

  private async onFilterResult (data: any) {
    this.filterResult = data
    this.currentPage = 1
    await this.initPageData()
    this.showHighFilter = false
  }

  // input搜索框
  inputChange () {
    console.log(this.searchVal)
  }

  // 表格操作鼠标移入
  mouseOver (index: any, row: any) {
    this.tableIndex = index
    this.changeData = row
  }

  saveInput () {
    this.tableIndex = ''
    this.editName()
    this.initPageData()
  }

  // 重命名 renameVisible
  editName () {
    console.log(this.rowDataObj)
  }

  // 下载
  downLoad (row: any) {
    console.log(row)
  }

  // 删除
  delete (row: any) {
    console.log(row)
  }

  // 弹框删除
  sureDetele () {
    console.log(22)
  }

  changeFun (val: any) {
    this.multipleSelection = val
  }
}
